// src/api/endpoints.ts

// API Endpoints
const ENDPOINTS = {
  // Restaurant API Paths
  RESTAURANT_DETAILS_API_PATH: import.meta.env.VITE_RESTAURANT_DETAILS_API_PATH,

  // Menu API Paths
  MENU_VIEW_API_PATH: import.meta.env.VITE_MENU_VIEW_API_PATH,
  SITE_CONTENT_VIEW_API_PATH: import.meta.env.VITE_SITE_CONTENT_VIEW_API_PATH,
  SITE_CONTENT_UPDATE_API_PATH: import.meta.env.VITE_SITE_CONTENT_UPDATE_API_PATH,
  SITE_CONTENT_PUBLISH_API_PATH: import.meta.env.VITE_SITE_CONTENT_PUBLISH_API_PATH,
  COMBO_API_PATH: import.meta.env.VITE_COMBO_API_PATH,

  // Order API Paths
  PLACE_ORDER_API_PATH: import.meta.env.VITE_PLACE_ORDER_API_PATH,
  PLACE_IN_DINING_ORDER: import.meta.env.VITE_PLACE_IN_DINING_ORDER,
  GET_IN_DINING_ORDERS: import.meta.env.VITE_GET_IN_DINING_ORDERS,
  UPDATE_IN_DINING_ORDERS: import.meta.env.VITE_UPDATE_IN_DINING_ORDERS,
  GET_INDINING_ORDERS: import.meta.env.VITE_GET_INDINING_ORDERS,

  // Table Management API Paths
  TABLE_AVAILABILITY: import.meta.env.VITE_TABLE_AVAILABILITY,
  TABLE_RESERVATION: import.meta.env.VITE_TABLE_RESERVATION,
  MAKE_RESERVATION: import.meta.env.VITE_MAKE_RESERVATION,
  GET_TABLE_STATUS: import.meta.env.VITE_GET_TABLE_STATUS,

  // Payment API Paths
  GET_PAYMENT_INFO: import.meta.env.VITE_GET_PAYMENT_INFO,
  MAKE_PAYMENT: import.meta.env.VITE_MAKE_PAYMENT,
  PAYMENT_STATUS_API_PATH: import.meta.env.VITE_PAYMENT_STATUS_API_PATH,

  // Delivery API Paths
  CREATE_DELIVERY_QUOTE_API_PATH: import.meta.env.VITE_CREATE_DELIVERY_QUOTE_API_PATH,
} as const;

export default ENDPOINTS;
